/* Build cart drawer items from /cart.js data — used when section rendering is unavailable (password-protected stores) */
function GYMSKYNS_renderCartDrawer(cart) {
  var itemsWrap = document.querySelector('#CartDrawer-CartItems');
  if (!itemsWrap) return;

  if (!cart.items || cart.items.length === 0) return;

  var rows = cart.items.map(function (item) {
    var img = item.image
      ? '<img class="cart-item__image" src="' + item.image.replace(/(\.\w+)$/, '_150x150$1') + '" alt="' + escHtml(item.title) + '" loading="lazy" width="75" height="75">'
      : '';
    var variantInfo = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<div class="product-option"><dt>Variant:</dt><dd>' + escHtml(item.variant_title) + '</dd></div>'
      : '';
    var price = formatMoney(item.final_line_price);
    return '<tr class="cart-item" role="row">'
      + '<td class="cart-item__media" role="cell"><a href="' + item.url + '" class="cart-item__link" tabindex="-1" aria-hidden="true"> </a>' + img + '</td>'
      + '<td class="cart-item__details" role="cell">'
      + '<div class="cart-item__title"><a href="' + item.url + '" class="cart-item__name h4 break">' + escHtml(item.product_title) + '</a></div>'
      + (variantInfo ? '<dl>' + variantInfo + '</dl>' : '')
      + '</td>'
      + '<td class="cart-item__totals right" role="cell"><div class="cart-item__price-wrapper"><span class="price price--end">' + price + '</span></div></td>'
      + '<td class="cart-item__quantity" role="cell">'
      + '<div class="cart-item__quantity-wrapper">'
      + '<span class="cart-item__quantity-text">Qty: ' + item.quantity + '</span>'
      + '</div></td>'
      + '</tr>';
  }).join('');

  var total = formatMoney(cart.total_price);
  itemsWrap.innerHTML = '<div class="drawer__cart-items-wrapper">'
    + '<table class="cart-items" role="table">'
    + '<thead role="rowgroup"><tr role="row">'
    + '<th role="columnheader"><span class="visually-hidden">Image</span></th>'
    + '<th class="caption-with-letter-spacing" scope="col" role="columnheader">Product</th>'
    + '<th class="right caption-with-letter-spacing" scope="col" role="columnheader">Total</th>'
    + '<th role="columnheader"><span class="visually-hidden">Quantity</span></th>'
    + '</tr></thead>'
    + '<tbody role="rowgroup">' + rows + '</tbody>'
    + '</table></div>';

  // Update subtotal
  var totalEl = document.querySelector('.totals__total-value');
  if (totalEl) totalEl.textContent = total;
}

function escHtml(str) {
  return String(str || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
}

function formatMoney(cents) {
  if (window.Shopify && window.Shopify.formatMoney) return window.Shopify.formatMoney(cents, '${{amount}}');
  return '$' + (cents / 100).toFixed(2);
}

/* Global cart helpers (available on every page) */
if (!window.GYMSKYNS_updateCartCount) {
  window.GYMSKYNS_updateCartCount = function (count) {
    var selector = '.cart-count, #cart-icon-bubble .cart-count, #cartCount';
    function bump(el) {
      el.classList.remove('bump');
      void el.offsetWidth;
      el.classList.add('bump');
    }
    if (typeof count === 'number') {
      document.querySelectorAll(selector).forEach(function (el) {
        el.textContent = count;
        el.classList.toggle('is-hidden', count === 0);
        bump(el);
      });
      return;
    }
    var cartJsonUrl = (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js';
    fetch(cartJsonUrl)
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var c = cart.item_count || 0;
        if (!c && cart.items) {
          cart.items.forEach(function (item) { c += item.quantity; });
        }
        document.querySelectorAll(selector).forEach(function (el) {
          el.textContent = c;
          el.classList.toggle('is-hidden', c === 0);
          bump(el);
        });
      })
      .catch(function () {});
  };
}

if (!window.GYMSKYNS_showCartToast) {
  window.GYMSKYNS_showCartToast = function (message) {
    var wrap = document.querySelector('.toast-wrap');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'toast-wrap';
      document.body.appendChild(wrap);
    }
    var toast = document.createElement('div');
    toast.className = 'toast';
    toast.textContent = message;
    wrap.appendChild(toast);
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () { toast.remove(); }, 400);
    }, 2500);
  };
}

/* Re-render the cart drawer from the real Liquid section so the AJAX-updated
   drawer looks identical to a fresh page load (stepper, remove button,
   PRODUCT/TOTAL headers) instead of the simplified JS-built fallback markup. */
if (!window.GYMSKYNS_refreshCartDrawer) {
  window.GYMSKYNS_refreshCartDrawer = function () {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return Promise.reject(new Error('no cart-drawer'));
    return fetch('/?section_id=cart-drawer')
      .then(function (r) {
        if (!r.ok) throw new Error('section render failed (' + r.status + ')');
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newInner = doc.querySelector('#CartDrawer');
        var oldInner = document.querySelector('#CartDrawer');
        if (!newInner || !oldInner) throw new Error('drawer markup missing');
        oldInner.innerHTML = newInner.innerHTML;
        /* is-empty lives on <cart-drawer> itself, outside #CartDrawer */
        var newDrawer = doc.querySelector('cart-drawer');
        if (newDrawer) cartDrawer.classList.toggle('is-empty', newDrawer.classList.contains('is-empty'));
        /* overlay node was replaced — rebind close */
        var overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
        if (overlay && typeof cartDrawer.close === 'function') {
          overlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));
        }
        /* the swap doesn't touch the header badge — sync it here so every
           drawer refresh also fixes the cart count without a reload */
        if (typeof window.GYMSKYNS_updateCartCount === 'function') {
          window.GYMSKYNS_updateCartCount();
        }
      });
  };
}

/* Global AJAX add-to-cart handler — intercepts product-card forms on collection / bestseller / new-arrival pages */
if (!window.GYMSKYNS_ajaxCartHandler) {
  window.GYMSKYNS_ajaxCartHandler = true;

  function GYMSKYNS_doAjaxAdd(form, submitBtn) {
    if (submitBtn && submitBtn.disabled) return false;
    var id = (form.querySelector('[name="id"]') || {}).value;
    if (!id) return false;
    var qty = parseInt((form.querySelector('[name="quantity"]') || {}).value, 10) || 1;
    if (submitBtn) {
      submitBtn.disabled = true;
      if (!submitBtn.dataset.originalText) submitBtn.dataset.originalText = 'Add to Cart';
      submitBtn.classList.add('btn--loading');
      submitBtn.classList.remove('btn--added');
      submitBtn.innerHTML = '<span class="btn-shine"></span>Adding\u2026';
    }
    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Server error (' + r.status + ')'); });
        return r.json();
      })
      .then(function (data) {
        if (data.status) throw new Error(data.description || 'Cart error');
        window.GYMSKYNS_updateCartCount(data.item_count);
        var productNameEl = form.querySelector('[data-product-name]');
        var productName = (productNameEl ? productNameEl.textContent : '') || data.product_title || '';
        window.GYMSKYNS_showCartToast(productName ? productName + ' \u2014 Added' : 'Added to cart');
        if (submitBtn) {
          submitBtn.classList.remove('btn--loading');
          submitBtn.classList.add('btn--added');
          submitBtn.innerHTML = '<span class="btn-shine"></span>Added!';
        }
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          // Swap in the real Liquid-rendered drawer so it matches a page load
          window.GYMSKYNS_refreshCartDrawer()
            .catch(function () {
              // Fallback: build simplified markup from /cart.js data
              return fetch('/cart.js')
                .then(function (r) { return r.json(); })
                .then(function (cart) {
                  GYMSKYNS_renderCartDrawer(cart);
                  cartDrawer.classList.remove('is-empty');
                  var inner = cartDrawer.querySelector('.drawer__inner');
                  if (inner) inner.classList.remove('is-empty');
                  /* footer (subtotal/checkout) is hidden by cart-drawer-items.is-empty */
                  var itemsEl = cartDrawer.querySelector('cart-drawer-items');
                  if (itemsEl) itemsEl.classList.remove('is-empty');
                  // Hide the "YOUR CART IS EMPTY" block
                  var emptyEl = cartDrawer.querySelector('.drawer__inner-empty');
                  if (emptyEl) emptyEl.style.display = 'none';
                });
            })
            .catch(function () {
              cartDrawer.classList.remove('is-empty');
            })
            .then(function () {
              if (typeof cartDrawer.open === 'function') { cartDrawer.open(); }
            });
        } else {
          var toggle = document.getElementById('cart-icon-bubble');
          if (toggle) toggle.click();
        }
        if (submitBtn) {
          setTimeout(function () {
            submitBtn.classList.remove('btn--added');
            if (submitBtn.dataset.originalText) {
              submitBtn.innerHTML = '<span class="btn-shine"></span>' + submitBtn.dataset.originalText;
            }
            submitBtn.disabled = false;
          }, 1200);
        }
      })
      .catch(function (err) {
        window.GYMSKYNS_showCartToast(err.message || 'Could not add to cart');
        if (submitBtn) {
          submitBtn.classList.remove('btn--loading', 'btn--added');
          if (submitBtn.dataset.originalText) {
            submitBtn.innerHTML = '<span class="btn-shine"></span>' + submitBtn.dataset.originalText;
          }
          submitBtn.disabled = false;
        }
      });
    return true;
  }

  /* Click handler — catches button clicks before form submits */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[name="add"]');
    if (!btn || btn.disabled) return;
    var form = btn.closest('form');
    if (!form || form.id === 'gymskyns-product-form') return;
    if (!form.action || !form.action.includes('/cart/add')) return;
    e.preventDefault();
    GYMSKYNS_doAjaxAdd(form, btn);
  });

  /* Submit handler — catches Enter-key and other submission paths */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.tagName !== 'FORM') form = form.closest('form');
    if (!form || form.id === 'gymskyns-product-form') return;
    if (!form.action || !form.action.includes('/cart/add')) return;
    if (!form.querySelector('[name="add"]')) return;
    e.preventDefault();
    var submitBtn = form.querySelector('[name="add"]');
    if (submitBtn && submitBtn.disabled) return;
    GYMSKYNS_doAjaxAdd(form, submitBtn);
  });
}

(function () {
  'use strict';

  var overlay = document.getElementById('quickViewOverlay');
  if (!overlay) return;

  var modal = document.getElementById('quickViewModal');
  var closeBtn = document.getElementById('quickViewClose');
  var qvImage = document.getElementById('qvImage');
  var qvThumbs = document.getElementById('qvThumbs');
  var qvVendor = document.getElementById('qvVendor');
  var qvName = document.getElementById('qvName');
  var qvPrice = document.getElementById('qvPrice');
  var qvDesc = document.getElementById('qvDesc');
  var qvOptions = document.getElementById('qvOptions');
  var qvQty = document.getElementById('qvQty');
  var qvAddBtn = document.getElementById('qvAddBtn');
  var qvViewFull = document.getElementById('qvViewFull');
  var qvError = document.getElementById('qvError');

  var currentProduct = null;
  var selectedOptions = [];
  var selectedVariant = null;
  var currentImageIndex = 0;

  function initQuickView() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-quick-view]');
      if (trigger) {
        e.preventDefault();
        var handle = trigger.getAttribute('data-quick-view');
        if (handle) openQuickView(handle);
        return;
      }
    });

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeQuickView();
    });

    closeBtn.addEventListener('click', closeQuickView);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
        closeQuickView();
      }
    });

    qvAddBtn.addEventListener('click', function (e) {
      e.preventDefault();
      addToCart();
    });

    qvOptions.addEventListener('click', function (e) {
      var pill = e.target.closest('[data-qv-option]');
      if (!pill || pill.classList.contains('is-disabled')) return;
      selectOption(pill);
    });

    modal.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty]');
      if (!btn) return;
      e.preventDefault();
      var dir = btn.getAttribute('data-qty');
      var val = parseInt(qvQty.value, 10) || 1;
      if (dir === 'dec' && val > 1) val--;
      if (dir === 'inc') val++;
      qvQty.value = val;
    });
  }

  function openQuickView(handle) {
    clearError();
    qvAddBtn.disabled = true;
    qvAddBtn.innerHTML = '<span class="btn-shine"></span>Loading...';

    overlay.classList.add('is-open');
    document.body.classList.add('no-scroll');

    fetch('/products/' + handle + '.js')
      .then(function (res) {
        if (!res.ok) throw new Error('Product not found');
        return res.json();
      })
      .then(function (product) {
        currentProduct = product;
        currentImageIndex = 0;
        populateModal(product);
      })
      .catch(function () {
        qvAddBtn.innerHTML = '<span class="btn-shine"></span>Unavailable';
        showError('Could not load product. Please try again.');
      });
  }

  function populateModal(product) {
    setImage(product, 0);
    renderThumbs(product, 0);

    qvVendor.textContent = product.vendor || 'GYMSKYNS';
    qvName.textContent = product.title;
    qvDesc.textContent = '';

    qvViewFull.setAttribute('href', '/products/' + product.handle);

    renderOptions(product);

    qvAddBtn.disabled = false;
  }

  function setImage(product, index) {
    if (!product.images || product.images.length === 0) {
      qvImage.innerHTML = '<span>' + product.title.toUpperCase() + '</span>';
      return;
    }
    index = Math.min(index, product.images.length - 1);
    currentImageIndex = index;
    qvImage.innerHTML = '<img src="' + product.images[index] + '" alt="' + escapeAttr(product.title) + '" loading="lazy">';
  }

  function renderThumbs(product, activeIndex) {
    if (!qvThumbs || !product.images || product.images.length < 2) {
      if (qvThumbs) qvThumbs.innerHTML = '';
      return;
    }

    qvThumbs.innerHTML = '';
    product.images.forEach(function (src, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'thumb-strip__btn';
      if (i === activeIndex) btn.classList.add('is-active');
      btn.setAttribute('data-qv-thumb', i);
      btn.innerHTML = '<img src="' + src + '" alt="" loading="lazy">';
      btn.addEventListener('click', function () {
        if (!currentProduct) return;
        setImage(currentProduct, i);
        var thumbs = qvThumbs.querySelectorAll('.thumb-strip__btn');
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
      qvThumbs.appendChild(btn);
    });
  }

  function renderOptions(product) {
    qvOptions.innerHTML = '';
    selectedOptions = [];
    selectedVariant = null;

    if (!product.options || product.options.length === 0 || (product.options.length === 1 && product.options[0].name === 'Title')) {
      if (product.variants && product.variants.length > 0) {
        selectedVariant = product.variants[0];
        updatePrice(selectedVariant);
        updateAddBtn(selectedVariant);
      }
      return;
    }

    product.options.forEach(function (opt, optIndex) {
      var block = document.createElement('div');
      block.className = 'option-block';

      var label = document.createElement('div');
      label.className = 'opt-label';
      var span = document.createElement('span');
      span.textContent = opt.name;
      label.appendChild(span);

      // Nested inside the same (first) span as the option name — matches
      // sections/gymskyns-product.liquid's "COLOR — ICE" pattern exactly,
      // including its dim/uppercase styling, for the currently selected color.
      var isColorOption = opt.name === 'Color' || opt.name === 'Colour';
      var valueSpan = null;
      if (isColorOption) {
        span.appendChild(document.createTextNode(' — '));
        valueSpan = document.createElement('span');
        valueSpan.setAttribute('data-opt-value-index', optIndex);
        span.appendChild(valueSpan);
      }

      block.appendChild(label);

      var row = document.createElement('div');
      row.className = 'size-row';

      selectedOptions[optIndex] = '';

      var values = opt.values || [];

      values.forEach(function (val, valIndex) {
        var pill = document.createElement('button');
        pill.type = 'button';
        pill.className = 'size-pill';
        pill.setAttribute('data-qv-option', '');
        pill.setAttribute('data-opt-index', optIndex);
        pill.setAttribute('data-val', val);
        pill.textContent = val;

        var allDisabled = true;
        product.variants.forEach(function (v) {
          var vOpt = v['option' + (optIndex + 1)];
          if (vOpt === val && v.available) allDisabled = false;
        });
        if (allDisabled) pill.classList.add('is-disabled');

        if (valIndex === 0 && !allDisabled) {
          pill.classList.add('is-selected');
          selectedOptions[optIndex] = val;
          if (isColorOption) valueSpan.textContent = val;
        }

        row.appendChild(pill);
      });

      block.appendChild(row);
      qvOptions.appendChild(block);
    });

    updateVariant(product);
  }

  function selectOption(pill) {
    var optIndex = parseInt(pill.getAttribute('data-opt-index'), 10);
    var val = pill.getAttribute('data-val');

    var group = pill.closest('.option-block');
    var siblings = group.querySelectorAll('[data-qv-option]');
    siblings.forEach(function (s) { s.classList.remove('is-selected'); });

    pill.classList.add('is-selected');

    var valueLabel = qvOptions.querySelector('[data-opt-value-index="' + optIndex + '"]');
    if (valueLabel) valueLabel.textContent = val;

    selectedOptions = currentProduct.options.map(function (opt, i) {
      if (i === optIndex) return val;
      return selectedOptions[i] || '';
    });

    updateVariant(currentProduct);
  }

  function updateVariant(product) {
    var found = null;

    product.variants.forEach(function (v) {
      var match = true;
      product.options.forEach(function (opt, i) {
        var selected = selectedOptions[i] || '';
        var vOpt = v['option' + (i + 1)] || '';
        if (selected.toLowerCase() !== vOpt.toLowerCase()) match = false;
      });
      if (match) found = v;
    });

    selectedVariant = found || null;

    if (selectedVariant && selectedVariant.featured_image && selectedVariant.featured_image.src) {
      var imgSrc = selectedVariant.featured_image.src;
      var imgIndex = product.images.indexOf(imgSrc);
      if (imgIndex !== -1) {
        setImage(product, imgIndex);
        var thumbs = qvThumbs.querySelectorAll('.thumb-strip__btn');
        thumbs.forEach(function (t, i) {
          t.classList.toggle('is-active', i === imgIndex);
        });
      }
    }

    updatePrice(selectedVariant);
    updateAddBtn(selectedVariant);
  }

  function updatePrice(variant) {
    if (!variant) {
      qvPrice.textContent = '\u2014';
      return;
    }

    var price = (variant.price / 100).toFixed(2);
    var compare = variant.compare_at_price ? (variant.compare_at_price / 100).toFixed(2) : null;

    if (compare && parseFloat(compare) > parseFloat(price)) {
      qvPrice.innerHTML = '<del>$' + compare + '</del> $' + price;
    } else {
      qvPrice.textContent = '$' + price;
    }
  }

  function updateAddBtn(variant) {
    if (!variant || !variant.available) {
      qvAddBtn.disabled = true;
      qvAddBtn.innerHTML = '<span class="btn-shine"></span>Sold Out';
      return;
    }

    qvAddBtn.disabled = false;
    qvAddBtn.innerHTML = '<span class="btn-shine"></span>Add to Cart';
  }

  function addToCart() {
    if (!selectedVariant || !selectedVariant.available) return;

    clearError();
    qvAddBtn.disabled = true;
    qvAddBtn.innerHTML = '<span class="btn-shine"></span>Adding...';

    var qty = parseInt(qvQty.value, 10) || 1;

    var formData = {
      'id': selectedVariant.id,
      'quantity': qty
    };

    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(formData)
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (e) { throw new Error(e.description || 'Cart error'); });
        return res.json();
      })
      .then(function (data) {
        qvAddBtn.innerHTML = '<span class="btn-shine"></span>Added!';
        if (typeof window.GYMSKYNS_showCartToast === 'function') {
          window.GYMSKYNS_showCartToast(currentProduct.title + ' added to cart');
        }
        if (typeof window.GYMSKYNS_updateCartCount === 'function') {
          window.GYMSKYNS_updateCartCount(data.item_count);
        }
        setTimeout(function () {
          closeQuickView();
          var cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && cartDrawer.open) {
            window.GYMSKYNS_refreshCartDrawer()
              .catch(function () {})
              .then(function () { cartDrawer.open(); });
          } else {
            var toggle = document.getElementById('cart-icon-bubble');
            if (toggle) toggle.click();
          }
        }, 600);
      })
      .catch(function () {
        qvAddBtn.disabled = false;
        qvAddBtn.innerHTML = '<span class="btn-shine"></span>Add to Cart';
        showError('Could not add to cart. Please try again.');
      });
  }

  function closeQuickView() {
    overlay.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
    currentProduct = null;
    selectedOptions = [];
    selectedVariant = null;
    currentImageIndex = 0;
    qvQty.value = '1';
    clearError();
  }

  function showError(msg) {
    qvError.textContent = msg;
    qvError.style.display = 'block';
  }

  function clearError() {
    qvError.textContent = '';
    qvError.style.display = 'none';
  }

  function escapeAttr(str) {
    if (!str) return '';
    return str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuickView);
  } else {
    initQuickView();
  }
})();